import { useApolloClient } from "@apollo/client";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { getAllOpportunityForAdmin } from "../../../GQL/queries";
import { titleAtoms } from "../../../shared/atoms/titleAtoms";
import { globalLoadingScreenAtom } from "../../../shared/globalStates";
import { toastError } from "../../../shared/helpers";
import CardJobs from "./CardJobs";
import Header from "./Header";

export default function Dashboard() {
  const client = useApolloClient();
  const [allOpportunity, setAllOpportunity] = useState([]);
  const setTitle = useSetRecoilState(titleAtoms);
  const setIsLoading = useSetRecoilState(globalLoadingScreenAtom)

  useEffect(() => {
    setTitle("Dashboard");
  }, []);

  const fetchAllOpportunity = async () => {
    try {
      setIsLoading(true)
      await getAllOpportunityForAdmin(client).then((data) =>
        setAllOpportunity(data)
      );
    } catch (error) {
      toastError(error)
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          overflow: "hidden",
          position: "sticky",
          top: "60px",
          backgroundColor: "white",
          zIndex: 10,
          left: 0,
          right: 0,
          margin: "-2px",
        }}
        className="pt-1"
      >
        <Header fetchAllOpportunity={fetchAllOpportunity} />
        <div style={{ mt: 2, mb: 3 }}></div>
      </div>
      <Grid container spacing={3} sx={{ zIndex: 1 }}>
        <Grid item xs={12}>
          <CardJobs
            allOpportunity={allOpportunity}
            setAllOpportunity={setAllOpportunity}
            fetchAllOpportunity={fetchAllOpportunity}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
